exports = module.exports = require("../../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".step-test-email .form-group[data-v-6435f604] {\n  margin-top: 80px;\n}\n.step-test-email .action-buttons[data-v-6435f604] {\n  display: flex;\n  gap: 12px;\n  justify-content: stretch;\n}\n.step-test-email .action-buttons button[data-v-6435f604] {\n  flex: 1;\n  justify-content: center;\n}\n", ""]);

// exports
